import Plyr from 'plyr';

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

const initProductVideo = (container) => {
  const video = container.querySelector('.product-video');
  if (!video || container.classList.contains('plyr--product-video')) return;

  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');

  const player = new Plyr(video, {
    controls: [
      'play-large',
      'play',
      'progress',
      'current-time',
    ],
    hideControls: true,
    clickToPlay: true,
    muted: true,
    keyboard: { focused: true, global: false },
    tooltips: { controls: true, seek: true },
    captions: { active: false, language: 'auto', update: false },
    fullscreen: { enabled: false, fallback: true, iosNative: false },
    autoplay: false,
    i18n: {
      play: 'Play',
      pause: 'Pause',
      seekLabel: '{currentTime} of {duration}',
    },
  });

  player.hasBeenManuallyInteracted = false;

  player.on('ended', () => {
    player.currentTime = 0;
  });

  let touchStartTime = 0;
  let touchEndTime = 0;
  let touchCount = 0;
  let touchTimeout = null;
  let isPauseLocked = false;
  let pauseLockTimeout = null;
  let lastActionTime = 0;
  let isProcessingTouch = false;

  player.on('play', () => {
    if (isPauseLocked) {
      player.pause();
    }
  });

  player.on('pause', () => {
    isPauseLocked = true;
    if (pauseLockTimeout) {
      clearTimeout(pauseLockTimeout);
    }
    pauseLockTimeout = setTimeout(() => {
      isPauseLocked = false;
    }, 500);
  });

  const handleClick = debounce(() => {
    if (!player.playing) {
      player.hasBeenManuallyInteracted = true;
    } else {
      player.hasBeenManuallyInteracted = false;
    }
  }, 300);

  container.addEventListener('click', handleClick);

  container.addEventListener('touchstart', () => {
    if (isProcessingTouch) return;
    touchStartTime = Date.now();
    touchCount++;
  }, { passive: true });

  container.addEventListener('touchmove', () => {
    touchCount = 0;
    isProcessingTouch = false;
  }, { passive: true });

  container.addEventListener('touchend', (e) => {
    if (e.target.closest('.plyr__controls')) return;
    if (isProcessingTouch || isPauseLocked) return;

    const now = Date.now();
    if (now - lastActionTime < 500) return;

    touchEndTime = now;
    const touchDuration = touchEndTime - touchStartTime;

    if (touchTimeout) {
      clearTimeout(touchTimeout);
    }

    if (touchDuration < 300) {
      isProcessingTouch = true;
      touchTimeout = setTimeout(() => {
        if (Date.now() - touchEndTime > 100 && touchCount > 0) {
          lastActionTime = Date.now();
          if (player.playing) {
            player.pause();
          } else {
            player.play();
          }
          touchCount = 0;
        }
        isProcessingTouch = false;
      }, 150);
    } else {
      touchCount = 0;
      isProcessingTouch = false;
    }
  }, { passive: true });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting && player.playing) {
        player.pause();
      } else if (entry.isIntersecting && !player.hasBeenManuallyInteracted) {
        player.play();
      }
    });
  }, {
    threshold: 0.5,
  });

  observer.observe(container);

  container.classList.add('plyr--product-video');
};

const initAllProductVideos = () => {
  const videoContainers = document.querySelectorAll('.product-video_container');
  videoContainers.forEach(initProductVideo);
};

document.addEventListener('DOMContentLoaded', initAllProductVideos);

export { initProductVideo };

window.initProductVideo = initProductVideo;
